export default __webpack_public_path__ + "static/media/12.6f66b714.webp";